import Button from "components/elements/Button/Button";
import { AutodeskImportState } from "../autodeskImportReducer";

export default function AutodeskImportResultsStep(p: {
  state: AutodeskImportState;
  onClose(): void;
}) {
  const outcomes = p.state.outcomes ?? [];
  const failed = outcomes.filter((outcome) => outcome.failure);
  const startedCount = outcomes.length - failed.length;
  const namesByItemId = new Map(
    (p.state.preview?.covered ?? []).map((file) => [file.itemId, file.name]),
  );

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-thin">
        Some files <span className="font-normal">couldn't be imported</span>
      </h1>
      <p className="text-sm font-light">
        {startedCount} of {outcomes.length} imports started.
      </p>
      <ul className="space-y-2 text-sm font-light">
        {failed.map((outcome) => (
          <li key={outcome.itemId} className="rounded-md border p-3">
            <p className="font-normal">
              {namesByItemId.get(outcome.itemId) ?? "Unknown file"}
            </p>
            <p className="text-gray-500">
              {outcome.message ?? "This file couldn't be imported."}
            </p>
          </li>
        ))}
      </ul>
      <footer className="flex justify-end border-t pt-4">
        <Button type="button" slim onClick={p.onClose}>
          Close
        </Button>
      </footer>
    </div>
  );
}
